export const getShareTokenByCreatorSlug = (creatorSlug: string) => {
  return `creator-share-${creatorSlug}`;
};

export const getShareTokenByAgencySlug = (agencySlug: string) => {
  return `agency-share-${agencySlug}`;
};
